import initTabelaGenerica from '../mixins/initTabelaGenerica'
import { URLS } from '../constants/urls'
import { Grid, html as htmlGrid } from 'gridjs'

export default {
	mixins: [initTabelaGenerica],
	props: { query: '' },
	data() {
		return {
			_gridThenCallback: null,
			_gridTotalCallback: null,
			listaPoliticaAgendamento: [],
			tabelaPoliticaAgendamento: null,
			columns: [
				{ id: 'id', name: 'ID', hidden: true },
				{
					id: 'nome_officer',
					name: 'Nome do Officer',
					attributes: {
						'sticky-column-1': true,
						'sticky-header': true,
					},
					hidden: false,
					width: '140px',
					formatter: (cell, row) => {
						return htmlGrid(`
                            <div class="inline-flex items-center max-w-[180px]">
                                <span class="one-line max-w-[180px]">${
																	cell || 'N/A'
																}</span>
                            </div>
            `)
					},
					sort: false,
				},
				{
					id: 'politicas_total',
					name: 'QTD de Políticas',
					hidden: false,
					sort: false,
					width: '120px',
					formatter: (cell, row) => {
						return htmlGrid(`
                            <div class="inline-flex items-center justify-center">
                                <span class="one-line">${cell || '0'}</span>
                            </div>
            `)
					},
				},
				{
					id: 'politicas_atendidas',
					name: 'QTD de Políticas Atendidas',
					hidden: false,
					width: '150px',
					sort: false,
					formatter: (cell, row) => {
						return htmlGrid(`
                            <div class="inline-flex items-center justify-center">
                                <span class="one-line">${cell || '0'}</span>
                            </div>
            `)
					},
				},
				{
					id: 'percentual',
					name: 'Percentual de Políticas Atendidas',
					hidden: false,
					width: '120px',
					sort: false,
					formatter: (cell, row) => {
						const percentual = parseFloat(cell) || 0

						// Cor baseada no percentual
						let colorClass = 'text-red-600'
						if (percentual >= 80) colorClass = 'text-green-600'
						else if (percentual >= 60) colorClass = 'text-yellow-600'

						return htmlGrid(`
                            <div class="inline-flex items-center justify-center">
                                <span class="one-line ${colorClass}">${
							cell || '0%'
						}</span>
                            </div>
            `)
					},
				},
			],
		}
	},
	methods: {
		iniciatabelaPoliticaAgendamento() {
			const tabela = document.querySelector('#tabela_politica_agendamento')

			this._gridThenCallback = (responseAtendimentos) => {
				return this.formataDadoTabela(responseAtendimentos) || []
			}

			this._gridTotalCallback = (responseAtendimentos) => {
				return responseAtendimentos.count
			}

			const optionsPaginacao = {
				pagination: {
					enabled: true,
					limit: 10,
					summary: true,
					server: {
						url: (urlApi, page, limit) => {
							const prefix = urlApi.includes('?') ? '&' : '?'

							return `${urlApi}${prefix}page=${++page}&per_page=${limit}`
						},
					},
				},
			}

			const optionsSort = {
				sort: {
					multiColumn: false,
					server: {
						url: (prev, columns) => {
							if (!columns.length || columns[0].index !== 3) return prev

							const col = columns[0]
							const dir = col.direction === 1 ? 'asc' : 'desc'
							return `${prev}&sort_order=${dir}`
						},
					},
				},
			}

			const optionsSearch = {
				search: {
					server: {
						url: (prev, keyword) => `${prev}?officer=${keyword}`,
					},
				},
			}

			this.tabelaPoliticaAgendamento = this.iniciarTabelaGenerica(
				this.columns,
				`${window.origin}${URLS.relatorio_politica_agendamento}`,
				this._gridThenCallback,
				this._gridTotalCallback,
				{ ...optionsPaginacao, ...optionsSort, ...optionsSearch }
			)

			this.tabelaPoliticaAgendamento.render(tabela)
		},

		atualizarTabelaComNovaQuery() {
			if (!this.tabelaPoliticaAgendamento) return

			let novaUrl = window.origin + URLS.relatorio_politica_agendamento
			if (this.query) {
				novaUrl += '?' + this.query
			}

			this.tabelaPoliticaAgendamento
				.updateConfig({
					pagination: {
						enabled: true,
						limit: 10,
						summary: true,
						server: {
							url: (urlApi, page, limit) => {
								const prefix = urlApi.includes('?') ? '&' : '?'

								return `${urlApi}${prefix}${
									this.query
								}&page=${++page}&per_page=${limit}`
							},
						},
					},
				})
				.forceRender()
		},

		formataDadoTabela(responseAgendamentos) {
			if (!responseAgendamentos || !responseAgendamentos.dados_officers) {
				console.warn('Estrutura de dados inválida:', responseAgendamentos)
				return []
			}

			const dadosOfficers = responseAgendamentos.dados_officers || []

			// Para GridJS, você pode mapear como objeto ou array
			const dadosFormatados = dadosOfficers.map((officer) => {
				// Opção 1: Como array (atual)
				/* return [
					officer.nome_officer || 'N/A',
					officer.politicas_total || 0,
					officer.politicas_atendidas || 0,
					`${officer.percentual || 0}%`,
				] */

				// Opção 2: Como objeto (alternativa)
				return {
					nome_officer: officer.nome_officer || 'N/A',
					politicas_total: officer.politicas_total || 0,
					politicas_atendidas: officer.politicas_atendidas || 0,
					percentual: `${officer.percentual || 0}%`,
				}
			})

			this.listaPoliticaAgendamento = dadosFormatados
			return dadosFormatados
		},
	},
	watch: {
		query(newVal, oldVal) {
			if (newVal !== oldVal) {
				this.atualizarTabelaComNovaQuery()
			}
		},
	},
	mounted() {
		this.iniciatabelaPoliticaAgendamento()
	},
	template: `
        <table
			id="tabela_politica_agendamento"
			class="!flex"
			js-table-ordenation
			style="margin-inline: 1rem"></table>
    `,
}
